import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Row, Typography, Spin } from 'antd';
import { Page } from '@components';
import { authSelector } from '@redux/slices/auth';
import { translate } from '@components/i18n';
import { ListCardsHome } from '@components/list-cards-home';
import { clearState as clearStateItems } from '@redux/slices/order/select-items';
import { clearTempItems } from '@redux/slices/order/bonification';
import { clearState as clearStateType } from '@redux/slices/order/select-type';
import { clearState as clearStateSeller } from '@redux/slices/order/select-seller';
import { clearState as clearStateDrafts } from '@redux/slices/order/drafts';
import { clearState as clearStateScheduled } from '@redux/slices/order/scheduled';
import { clearStateCampaign } from '@redux/slices/campaign';
import { clearState as clearStateMinOrder } from '@redux/slices/min-order';
import { clearState as clearStateItems2 } from '@redux/slices/item';
import { clearState as clearStateUsers } from '@redux/slices/users';
import { clearState as clearStateRoutes } from '@redux/slices/route';
import { clearState as clearStateAuthorizedClients } from '@redux/slices/authorized-clients';
import { clearState as clearStateDistributor } from '@redux/slices/distributor';
import { clearState as clearStateTransferCampaign } from '@redux/slices/transfer-campaign';
import { clearState as clearStateItemDeadline } from '@redux/slices/item-deadline';
import { clearState as clearStateTransferItem } from '@redux/slices/transfer-item';
import { clearState as clearStateRestrictedItems } from '@redux/slices/restricted-items';
import { clearState as clearStateDivisions } from '@redux/slices/divisions';
import { clearState as clearStateSemaphore } from '@redux/slices/semaphore';
import { clearStateBalance } from '@redux/slices/balance';
import { clearState as clearStateTransferOrderDraft } from '@redux/slices/transfer-order/draft';
import { clearState as clearStateTransferOrderHistory } from '@redux/slices/transfer-order/history';
import { clearStateApprovalGroup } from '@redux/slices/approval-groups';
import { clearState as clearStateMoneyType } from '@redux/slices/money-type';
import { clearState as clearStateNotification } from '@redux/slices/notification';
import { clearStateDelegation } from '@redux/slices/delegation';
import { clearState as clearStateDeadline } from '@redux/slices/deadline';
import { clearState as clearStateParameters } from '@redux/slices/config';
import { clearState as clearStateCost } from '@redux/slices/cost';
import { clearState as clearStateTransferClients } from '@redux/slices/transfer-clients';
import { clearStateApprovalMarketing } from '@redux/slices/approval-marketing';

const Home: React.FC = () => {
    const dispatch = useDispatch()
    const authState = useSelector(authSelector);
    const [isClearing, setIsClearing] = useState(true);

    useEffect(() => {
        const clearAllStates = async () => {
            // Clear all global states except auth
            dispatch(clearTempItems())
            dispatch(clearStateItems())
            dispatch(clearStateType())
            dispatch(clearStateSeller())
            dispatch(clearStateDrafts())
            dispatch(clearStateScheduled())
            dispatch(clearStateCampaign())
            dispatch(clearStateMinOrder())
            dispatch(clearStateItems2())
            dispatch(clearStateUsers())
            dispatch(clearStateRoutes())
            dispatch(clearStateAuthorizedClients())
            dispatch(clearStateDistributor())
            dispatch(clearStateTransferCampaign())
            dispatch(clearStateItemDeadline())
            dispatch(clearStateTransferItem())
            dispatch(clearStateRestrictedItems())
            dispatch(clearStateDivisions())
            dispatch(clearStateSemaphore())
            dispatch(clearStateBalance())
            dispatch(clearStateTransferOrderDraft())
            dispatch(clearStateTransferOrderHistory())
            dispatch(clearStateApprovalGroup())
            dispatch(clearStateMoneyType())
            dispatch(clearStateNotification())
            dispatch(clearStateDelegation())
            dispatch(clearStateDeadline())
            dispatch(clearStateParameters())
            dispatch(clearStateCost())
            dispatch(clearStateTransferClients())
            dispatch(clearStateApprovalMarketing())

            // Simular um pequeno delay para garantir que todos os dispatches foram processados
            setTimeout(() => {
                setIsClearing(false);
            }, 100);
        };

        clearAllStates();
    }, [])

    return (
        <Page title={translate('pages.home')}>
            <Col span={24} style={{ marginTop: '50px' }}>
                <Row justify="center">
                    <Col span={2} />
                    <Col span={18}>
                        <Row justify="start">
                            <Typography.Title
                                level={3}
                                style={{ marginBottom: 0 }}
                            >
                                {translate('home.hello')}{' '}
                                {authState.currentUser?.name?.split(' ')[0]}
                            </Typography.Title>
                        </Row>
                        <Col>
                            <Row justify="start">
                                <Typography.Title
                                    level={3}
                                    style={{
                                        fontWeight: 400,
                                        marginBottom: 40,
                                    }}
                                >
                                    {translate('home.welcome')}
                                </Typography.Title>
                            </Row>
                        </Col>
                        <Col>
                            {isClearing ? (
                                <Row justify="center" style={{ padding: '50px 0' }}>
                                    <Spin size="large" />
                                </Row>
                            ) : (
                                <ListCardsHome />
                            )}
                        </Col>
                    </Col>
                </Row>
            </Col>
        </Page>
    );
};

export default Home;
